import {CustomScheduleComponent} from "./CustomScheduleComponent";
import {EmployeeSchedule} from "../../../model/schedule.model";
import {JobInfoManager} from "../../../model/JobInfoManager";
import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  forwardRef,
  Inject,
  Input
} from "@angular/core";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {CustomWeeklyModel} from "./CustomWeeklyModel";
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AvailableJobAggregation, DayType, MaskFormats, ModalResult, ScheduleType} from "../../../model/common.model";
import {CustomComponent} from "./CustomComponent";
import {DlgErrorMessage} from "../../../common/DlgErrorMessage";
import {AlertService} from "../../../services/alert.service";
import {ClientService} from "../../../services/client.service";
import {DlgWorkShiftRequestComponent} from "../../memo/DlgWorkShiftRequestComponent";
import {MemoContentWorkShift} from "../../memo/model/MemoContentWorkShift";
import {MemoAggregation, MemoInformation, MemoInformationType} from "../../memo/model/MemoAggregation";
import {JSonSerializer} from "../../../model/JSonSerializer";
import {DateEncoding} from "../../../model/DateEncoding";
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";
import {DisplayInterval} from "../../../directives/displayInterval";

import {Utils} from "../../../model/Utils";
import * as moment from "moment";
import {EmployeeAvailabilitySpecial} from "../../memo/model/EmployeAvailabilitySpecial";
import {ValidateStartEndTimeIntervalDirective} from "../../../directives/ValidateStartEndTimeIntervalDirective";
import {MyDateFormat} from "../../../directives/my.date.format";
import {EmployeeHoraire} from "../../../model/EmployeHoraire";


@Component({
  templateUrl: 'CustomCellComponent.html'
})
export class CustomCellComponent extends CustomComponent implements AfterViewInit,AfterContentChecked,AfterContentInit,AfterViewChecked{

  public loading = false;

  @Input()
  public container: CustomScheduleComponent;
  protected hasErrors = false;

  @Input()
  public refDate: Date;

  @Input()
  public verifyDragAndDropScope = true;

  protected model : CustomWeeklyModel;

  @Input() dayType: DayType;


  @Input() error = {messages : []};

  @Input() schedules : EmployeeSchedule[];

  //Edit in place
  @Input() editable = false;
  scheduleStartEndMask = MaskFormats.INTERVAL_HOUR_FORMAT_24_ANY_MINUTES;
  private _editDateFormat = new MyDateFormat(this.translate,this.session);


  protected displayInterval : DisplayInterval;



  protected _dragScope = new Array<string>();
  protected _dropScope = new Array<string>();




  //
  // uiMarker = 0;
  // uiMarkerMessage: SafeHtml;

  constructor (
    @Inject(forwardRef(() => AlertService)) protected alertService: AlertService,
    @Inject(forwardRef(() => ClientService)) protected clientService: ClientService,
    @Inject(forwardRef(() => DomSanitizer)) protected domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) protected modalService: NgbModal,
    @Inject(forwardRef(() => SessionService)) protected session: SessionService,
    @Inject(forwardRef(() => TranslateService)) protected translate: TranslateService
)
  {
     super('CustomCellComponent');
     this.displayInterval = new DisplayInterval(this.session);

    if (this.session.userInfo.isAMPM()){
      this.scheduleStartEndMask = MaskFormats.INTERVAL_HOUR_FORMAT_AM_PM_ANY_MINUTES;
    }


  }


  public retrieveScheduleStartEndDate(bean:EmployeeSchedule){
    console.log('isAMPM: ' +  this.session.userInfo.isAMPM());
    return this._editDateFormat.transform(bean.startHour,'LT','xx:xx') + '-' + this._editDateFormat.transform(bean.endHour,'LT','xx:xx');
  }



  private _verifyMessageForThisEmployee(bean: EmployeeSchedule):boolean{
    if (!Utils.isEmpty(bean.employeeId)){
       if (!Utils.isNullOrUndefined(this.model['employee'])){
          if (bean.employeeId!==this.model['employee']['id']){
            console.log('Not the same employee');
            return false;
          }
       }
    }
    return true;
  }



  public prepareDragAndDropScope(){
    /*
    this._dragScope = new Array<string>();
    if (this.schedules){
      for ( const bean of this.schedules ) {
        if (this._dragScope.indexOf(bean.jobId+'.' + bean.unitId)<=0){
          this._dragScope.push(bean.jobId+'.' + bean.unitId);
        }
      }
    }
    this._dropScope = new Array<string>();
    const jobUnitAndEmployees =  this.model.jobUnitAndEmployeeManager.retrieveByEmployeeId(this.model.employee.id);
    if (jobUnitAndEmployees){
      for (const bean of jobUnitAndEmployees){
        this._dropScope.push(bean.keyJobUnit);
      }
    }

    console.log(this.model.employee.fullName+ ' ' + this._dragScope + ', ' + this._dropScope,this.schedules);

     */

  }

  public get dragScope():string[]{
    return this._dragScope
  }

  public get dropScope():string[]{
    return this._dropScope
  }




  /**
   * Making sure that same error message is not written twice.
   */
  protected addErrorMessage(bean: EmployeeSchedule, schedules: EmployeeSchedule[], jobInfoManager: JobInfoManager):boolean{
    let res = false;
    // console.log('addErrorMessage if necessary');
    //console.log('begin AddErrorMessage bean ',bean);
    if (this._verifyMessageForThisEmployee(bean)==false){
      console.log('Not Adding message');
      return false;
    }
    let msgs = this._createErrorMessage(bean,schedules,this.session.jobManager);
    if (msgs.length>0){
      this.hasErrors = true;
      for (const msg of msgs){
        let found = false;
        for (const tmp of this.error.messages){
          if (tmp === msg){
            found = true;
            break;
          }
        }
        if (!found){
          this.error.messages.push(msg);
          res = true;
        }
      }
    }
    // console.timeEnd('addErrorMessage ' + bean.id);
    //console.log('end AddErrorMessage ',this.error);
    return res;
  }

  public isAfterToday() {
    return this.model.isAfterToday(this.dayType);
  }


  public validateErrorsForOtherLines(){
    console.log('Trying to validate Errors for OtherLine ' + this.schedules.length + ' schedules.');
    for (const bean of this.schedules ) {
      if (this.container.manager){
        console.log('container is not null.');
        this.container.manager.validateErrorsForOtherContainer(this.container, DayType.retrieveFromDate(bean.refDate));
      }
    }
  }


  public validateErrorsForOtherLinesWithDayType(dtType: DayType){
    console.log('Trying to validate Errors for OtherLine same DayType: ' + this.dayType);
    if (this.container.manager){
      console.log('container is not null.');
      this.container.manager.validateErrorsForOtherContainer(this.container,dtType);
    }
  }

  public validateErrorsForOtherContainerWithEmployee(employeeId: string){
    console.log('Trying to validate Errors for OtherLine same Employee: ' + employeeId);
    if (this.container.manager){
      console.log('container is not null.');
      this.container.manager.validateErrorsForOtherContainerWithEmployee(this.container,employeeId);
    }
  }




  public addErrorMessageForSchedulesInConflictForOtherLines(beans: EmployeeSchedule[]):boolean{
    console.log('addErrorMessageForSchedulesInConflictForOtherLines for schedules : ' + beans.length + ' schedules');
    if (this.container.manager){
      console.log('container is not null.');
      return this.container.manager.addErrorMessageForSchedulesInConflict(this.container,beans);
    }
    return false;
  }

  //protected addAfterDrop(toAdd: EmployeeSchedule[],workShiftBonuses: WorkShiftBonus[]){
  protected addAfterDrop(toAdd: EmployeeSchedule[]):boolean{
    let res = false;
    if (!this.session.isGreaterThanREAD_ONLY_LIMITED_REPONSABLE()){
      return false;
    }
    // Added in two steps to avoid drag and drop on the same cell.
    /*
    if (workShiftBonuses){
      for (const workShiftBonus of workShiftBonuses){
        this.model.workShiftBonusManager.add(workShiftBonus);
      }
    }

     */
    for (const bean of toAdd) {
      if (this.model.add(bean)){
        // console.log('Added : '  + JSON.stringify(bean, null, 2));
        if (!this.model.isThisHoldingSchedulesToBeFilled){
          this.validateAll([bean]);
        }
        res = true;
      }else{
        const modalRef = this.modalService.open(DlgErrorMessage);
        this.alertService.registerModal(modalRef);
        modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('Schedule.is.overlapping'));
        modalRef.result.then((result) => {
          //console.log( 'Closed with: ' + JSON.stringify(result,null, 2));
          this.validateAll([bean]);
          return false;
        }, (reason) => {
          console.log(`Dismissed ${this.getDismissReason(reason)}`);
          return false;
        });

      }
      /*
      if (this.session.autoSaveSchedules){
        if (bean.template === true){
          console.log('*** AutoSave Mode Template');
          this.model.autoSaveTemplate.onSaveTemplate();
        }
      }

       */

    }

  //  this.autoSaveIfRequired();
    return res;

  }

  protected autoSaveIfRequired(){
    if (this.session.autoSaveSchedules){
      if (this.model.autoSaveTemplate){
        console.log('*** AutoSave Mode Template');
        this.model.autoSaveTemplate.onSaveTemplate();
      }
      if (this.model.autoSave){
        console.log('*** AutoSave Mode Schedule');
        this.model.autoSave.onSaveSchedule();
      }
    }

  }


  protected validateAll(beans: EmployeeSchedule[], dt?: DayType,employeeId?: string){

    if (this.session.manualValidationSchedule === true){
      // console.log('Validate for Errors MANUAL VALIDATION only');
      return;
    }

    // console.log('validateAll');

    if (this.model.isThisHoldingSchedulesToBeFilled){
      return;
    }
    this.validateForErrors();
    if (employeeId){
      this.validateErrorsForOtherContainerWithEmployee(employeeId);
    }else{
      if (dt){
        this.validateErrorsForOtherLinesWithDayType(dt);
      }else{
        this.validateErrorsForOtherLines();
      }
    }

    if (this.addErrorMessageForSchedulesInConflictForOtherLines(beans)){
      // console.log('Added error message for schedule in error');
    }

  }

  private _shouldValidate(){
    if (this.schedules){
      for (const bean of this.schedules ) {
        if (bean.toValidate === true){
          return true;
        }
      }
    }
    return false;
  }

  public validateForErrors(forceManualValidation?:boolean) {
    if (Utils.isNullOrUndefined(forceManualValidation) || forceManualValidation===false){
      if (this.session.manualValidationSchedule === true){
        return;
      }
      // console.time('validateForErrors');
      // console.log('Validating For Errors ' + this.schedules.length + ' schedules. ' + this.dayType + ' ' + this.refDate);
      if (this._shouldValidate() === false){
        // console.time('No need to validate');
        return;
      }
    }

    this.error.messages = new Array<string>();
    this.hasErrors = false;


    // console.log('other ScheduleManager debug: ' + this.model.otherScheduleManager.debug());
    //console.log('debug: ' + this.model.otherScheduleManager.debug());

    for (const bean of this.schedules ) {
      // console.time('validateSchedule ' + bean.id);
      // if (Utils.isNullOrUndefined(bean.employeeId) && Utils.isNullOrUndefined(bean.employee)){
      if (Utils.isNullOrUndefined(bean.employee.id)){
        console.log('Validation for error: ' + bean.refDate + ' ' + bean.id + ' no employee info, no validation.');
        continue;
      }
      // Wont check for availabilities if Schedule type is Vacations,...
      // console.log('Validation for error: ' + bean.refDate + ' ' + bean.id + ' ' + bean.type + ' ' + bean.jobId + ' ' + bean.unitId);
      // console.time('validateScheduleInactivity ' + bean.id);
      const inactivity = this.model.inactivityManager.retrieveMostAccurateHiringDetailForDate(bean.employee.id,bean.refDate);
      // console.timeEnd('validateScheduleInactivity ' + bean.id);
      if (!Utils.isNullOrUndefined(inactivity)){
        // console.time('checkingInactivity ' + bean.id);
         console.log('Checking Inactivity',inactivity);
        let reason = '';
        if (!Utils.isNullOrUndefined(inactivity.hiringDetail.reason)){
          reason = this.translate.instant(inactivity.hiringDetail.reason.toString());
        }
        let note = '';
        if (!Utils.isNullOrUndefined(inactivity.hiringDetail.note)){
          note = inactivity.hiringDetail.note;
        }
        this.error.messages.push(this.translate.instant('ThisEmployeeIsNotActive', {fn: bean.employee.fullName, reason:reason, note: note}));
        this.hasErrors = true;
        // console.timeEnd('checkingInactivity ' + bean.id);
      }

      if (!bean.type){
        console.log('Error schedule type is null setting TRAVAIL.');
        bean.type = ScheduleType.TRAVAIL;
      }

      if (!ScheduleType.isAmong(bean.type.code,ScheduleType.VACANCE, ScheduleType.FERIE, ScheduleType.CONGE_AVEC_SOLDE, ScheduleType.CONGE_SANS_SOLDE)){
        // console.log('Verifying AvailabilityManager');
        const availability =this.model.availabilityManager.hasSomeAvailabilityPrecise(bean.employee.id, bean.refDate, bean.startHour, bean.endHour);
        //{available:boolean,special: EmployeeAvailabilitySpecial}
      //  console.log('Result AvailabilityManager ',availability);

        if (!availability.available) {

          this._addPreciseMessage(bean,availability.special);

          // this.error.messages.push(this.translate.instant('ThisEmployeeIsNotAvailable', {fn: bean.employee.fullName}));
          // this.hasErrors = true;


        }else {
          this._addPreciseMessageWithSchedule(bean);
          // console.time('validateScheduleAvailability ' + bean.id);

          // console.timeEnd('validateScheduleAvailability ' + bean.id);

        }
      }
      /*
      if (this.container.manager){
        let schedules = this.container.manager.findSchedulesInConflict(bean);
        // console.log('Verifying Schedules in Conflict: ' +  JSON.stringify(schedules,null,2));
        this.addErrorMessage(bean,schedules, this.session.jobManager);
      }
      */
      // console.time('addingErrorMessage ' + bean.id);
      this.addErrorMessageForSchedulesInConflict(bean);
      // console.timeEnd('addingErrorMessage ' + bean.id);

      bean.toValidate = false;
      // console.timeEnd('Validate');
      // console.timeEnd('validateSchedule ' + bean.id);

    }
    if (this.hasErrors){
     // console.log('has Errors Messages: ' + this.hasErrors + ' nb Errors: ' + this.error.messages.length);
    }
  }

  protected _addPreciseMessage(bean: EmployeeSchedule, sp: EmployeeAvailabilitySpecial){
      let whenStr = '';
    //   console.log('schedule: ',bean);
    // console.log('special: ',sp);
      if (Utils.isNullOrUndefined(sp)){
        this.error.messages.push(this.translate.instant('ThisEmployeeIsNotAvailable', {fn: bean.employee.fullName}));
        this.hasErrors = true;
        return;
      }

      if (moment(bean.refDate).isSame(moment(sp.date), 'day')) {

        console.log('found a special event for ' + moment(bean.refDate).format('LL') + ' ' + sp.available + ' ' + moment(sp.startHour).format('LTS') + ' ' + moment(sp.endHour).format('LTS'));
        if (('00:00:00' === moment(sp.startHour).format('LTS') && ('23:59:59'===moment(sp.endHour).format('LTS'))) ){
           this.error.messages.push(this.translate.instant('ThisEmployeeIsNotAvailable', {fn: bean.employee.fullName}));
           this.hasErrors = true;
           return;
        }

        if (Utils.isAfterRefDate(sp.startHour,bean.endHour) || Utils.isBeforeRefDate(sp.endHour,bean.startHour)){
          console.log('Outside the schedule ');
          this.hasErrors = false;
        }

        whenStr += this.displayInterval.displayDates(sp.startHour,sp.endHour,this.session.userInfo.isAMPM());

        this.error.messages.push(this.translate.instant('ThisEmployeeIsNotAvailablePrecise', {fn: bean.employee.fullName,when:whenStr}));
        this.hasErrors = true;

        // console.log('Inside the schedule')
        // return {available:sp.available,special:sp};;
      }



  }

  protected _addPreciseMessageWithSchedule(bean: EmployeeSchedule){
    const dates = this.model.availabilityManager.retrieveWhenNotAvailable(bean.employee.id, bean.refDate, bean.startHour, bean.endHour);// Has SomeAvailability
    if (dates.length>0){
      let id = 0;
      let whenStr = '';
      while (id<dates.length){
        if (whenStr.length>0){
          whenStr += ', ';
        }
        let start = dates[id];
        let end = dates[id+1];
        // console.log('checking ' + start + ' end: ' + end + ' endHour' + bean.endHour)
        if (Utils.isAfterRefDate(Utils.mixDateAndHourMinute(bean.refDate,dates[id+1]),Utils.mixDateAndHourMinute(bean.refDate,bean.endHour))){
          end = bean.endHour;
        }
        if (Utils.isBeforeRefDate(Utils.mixDateAndHourMinute(bean.refDate,dates[id]),Utils.mixDateAndHourMinute(bean.refDate,bean.startHour))){
          start = bean.startHour;
        }
        whenStr += this.displayInterval.displayDates(start,end,this.session.userInfo.isAMPM());
        id+= 2;
      }
      this.error.messages.push(this.translate.instant('ThisEmployeeIsNotAvailablePrecise', {fn: bean.employee.fullName,when:whenStr}));
      this.hasErrors = true;
    }

  }



  public addErrorMessageForSchedulesInConflict(bean: EmployeeSchedule):boolean{
    if (this.container.manager){
      let schedules = [];
      if (!bean.deleting){
        // console.time('addErrorMessageForSchedulesInConflict ' + bean.id);
        schedules = this.container.manager.findSchedulesInConflict(bean);
        // console.timeEnd('addErrorMessageForSchedulesInConflict ' + bean.id);
      }else{
        console.log('checking EmployeeSchedule that is deleting');
      }
      console.log('schedules in conflict: ' + schedules.length,this.model);
     // console.log('Verifying Schedules in Conflict: ' +  JSON.stringify(schedules,null,2) + ' with: ' + bean.refDate + ' ' +bean.startHour + ' ' + bean.endHour + ' ' + bean.employeeId);
      return this.addErrorMessage(bean,schedules, this.session.jobManager);
    }
  }

  private _createErrorMessage(checkingSchedule: EmployeeSchedule,  schedules: EmployeeSchedule[], jobManager: JobInfoManager) : string[]{
    // console.time('_createErrorMessage ' + checkingSchedule.id);
    const messages = new Array<string>();
    if (schedules) {
      if ( schedules.length > 0 ) {
        const di = new DisplayInterval(this.session);
        for (const es of schedules ) {
          if (checkingSchedule.id === es.id) {
            continue;
          }


          const when = di.displayDates(es.startHour,es.endHour,this.session.userInfo.isAMPM());

          const jobAndUnitInfo = jobManager.getJobByJobIdAndUnitId(es.jobId, es.unitId);
          if (jobAndUnitInfo!=null){
            messages.push(this.translate.instant('ThisEmployeeAlreadyScheduled', {fn: checkingSchedule.employee.fullName, fullJobDescription: jobAndUnitInfo.fullDescription, when: when }));
          }else{
            // TODO: This is a bug the jobManager has not been loaded.
            messages.push(this.translate.instant('ThisEmployeeAlreadyScheduled', {fn: checkingSchedule.employee.fullName, fullJobDescription: '', when: when}));
          }
        }
      }
    }
    // console.timeEnd('_createErrorMessage ' + checkingSchedule.id);
    return messages;

  }



  protected getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  public explainScheduleDefault(bean: EmployeeSchedule): string{
    return '';
  }


  public isTrainingShift(bean:EmployeeSchedule){
    switch (bean.type){
      case ScheduleType.FORMATION:
        return true;
    }
    return false;
  }

  public isShadowingShift(bean:EmployeeSchedule){
    switch (bean.type){
      case ScheduleType.ENTRAINEMENT:
        return true;
    }
    return false;
  }

  getBackgroundColor():SafeStyle{
    let backgrounColor = '#ffffff';
    return this.domSanitizer.bypassSecurityTrustStyle(backgrounColor);
  }

  public isNotWork(bean:EmployeeSchedule):boolean{
    // console.log('Checking bean.type: ' + bean.type);
    switch (bean.type){
      case ScheduleType.FERIE:
        return true;
      case ScheduleType.VACANCE:
        return true;
      case ScheduleType.CONGE_AVEC_SOLDE:
        return true;
      case ScheduleType.CONGE_SANS_SOLDE:
        return true;
      case ScheduleType.BANK_TYPE:
        return true;
    }
    return false;
  }

  private _oldExplainationKeptForValidation = null;

  public explainModif(bean: EmployeeSchedule){
    let res = '';
    if (bean){
      if (!Utils.isNullOrUndefined(bean.lastScheduleChangeDt) && !Utils.isNullOrUndefined(bean.lastScheduleChangeByEmployee)){
        res = this.translate.instant('LastModificationOnAndBy',{modifBy:bean.lastScheduleChangeByEmployee,modifOn:moment(bean.lastScheduleChangeDt).format('lll')});
      }
      if (!Utils.isNullOrUndefined(bean.lastTimeSeenByEmployee)){
        if (res.length>0){
          res += '\n';
        }
        res += this.translate.instant('LastTimeSeenByEmployee',{lastTimeSeen:moment(bean.lastTimeSeenByEmployee).format('lll')});
      }
   }
    return res;
  }

  public scheduleTypeNeedsHours(bean:EmployeeSchedule){
    if (ScheduleType.isAmong(bean.type.code,ScheduleType.TRAVAIL,ScheduleType.ENTRAINEMENT,ScheduleType.FORMATION)){
      return true;
    }

    return false;
  }

  public explainSchedule(bean: EmployeeSchedule):string{
    // console.log('schedule Type: ' + bean.type +  ' type: '  +  typeof bean.type);
    let res = '';
    // if (ScheduleType.VACANCE === bean.type){
    //   console.log('Vacances!!!');
    // }
    switch (bean.type){
      case (ScheduleType.VACANCE):
        res = this.translate.instant(ScheduleType.VACANCE.toString());
        break;
      case (ScheduleType.CONGE_AVEC_SOLDE):
        res = this.translate.instant(ScheduleType.CONGE_AVEC_SOLDE.toString());
        break;
      case (ScheduleType.FERIE):
        res = this.translate.instant(ScheduleType.FERIE.toString());
        break;
      case (ScheduleType.CONGE_SANS_SOLDE):
        res = this.translate.instant(ScheduleType.CONGE_SANS_SOLDE.toString());
        break;
      case (ScheduleType.BANK_TYPE):
        res = this.translate.instant(ScheduleType.BANK_TYPE.toString());
        break;
      case (ScheduleType.FAMILY_LEAVE_UNPAID):
        res = this.translate.instant(ScheduleType.FAMILY_LEAVE_UNPAID.toString());
        break;
      case (ScheduleType.FAMILY_LEAVE_PAID):
        res = this.translate.instant(ScheduleType.FAMILY_LEAVE_PAID.toString());
        break;
      case (ScheduleType.BEREAVEMENT_LEAVE_UNPAID):
        res = this.translate.instant(ScheduleType.BEREAVEMENT_LEAVE_UNPAID.toString());
        break;
      case (ScheduleType.BEREAVEMENT_LEAVE_PAID):
        res = this.translate.instant(ScheduleType.BEREAVEMENT_LEAVE_PAID.toString());
        break;
      case (ScheduleType.SICK_LEAVE_UNPAID):
        res = this.translate.instant(ScheduleType.SICK_LEAVE_UNPAID.toString());
        break;
      case (ScheduleType.SICK_LEAVE_PAID):
        res = this.translate.instant(ScheduleType.SICK_LEAVE_PAID.toString());
        break;


      default:
        res = this.explainScheduleDefault(bean);
        break;
    }
    // console.log('res: ' + res);
    /**
     * Done to validate cell if the the explanation changed.
     * UseCase: Adding a Template/Gabarit is done through the model.
     */
    /*
    if (res !== this._oldExplainationKeptForValidation){
      this._oldExplainationKeptForValidation = res;
      setTimeout(()=>{
         this.validateForErrors();
      },500)
    } */


    /*
    if (bean.toValidate === true){
      console.log('Starting timer to validate');
      bean.toValidate = false;
      setTimeout(()=>{
        this.validateForErrors();
      },100);
    }
    */

    /*else{
      console.log('No need to validate!');
    } */

    return res;
    // {{bean.startHour | myDateFormat:'LT'}}&nbsp;-&nbsp;{{bean.endHour | myDateFormat:'LT'}}
  }


  public onHasErrors(): boolean {
    return this.hasErrors;
  }



  public sendRequestForWorkshift(startHour: Date, endHour: Date, jobId: string, unitId: string, note: string){
    const bean = new MemoAggregation();
    bean.info = new MemoInformation();
    bean.info.active = true;
    bean.info.type = MemoInformationType.WORK_SHIFT;

    const contenu = new MemoContentWorkShift();

    const de = new DateEncoding();
    contenu.startHour = startHour;
    contenu.endHour =endHour;
    // contenu.interval = de.encode(startHour,endHour);
    contenu.unitId = unitId;
    contenu.jobId = jobId;
    contenu.note = note;
    contenu.eventDate = this.model.getRefDate(this.dayType);
    this._editWorkshiftRequest(bean,contenu);
  }



  private _editWorkshiftRequest(bean: MemoAggregation, contenu?: MemoContentWorkShift){

    this.loading = true;
    this.alertService.clear();

    this.clientService.getAvailableJobAggregation().then(
      (res) => {
        if (res.success) {
          // console.log('AvailableJobAggregation is ' + JSON.stringify(res.data, null, 1));
          const _availableJobAggregation = new AvailableJobAggregation();
          const serializer = new JSonSerializer();
          serializer.deserialize(res.data, _availableJobAggregation);
          this._editWorkshiftRequestInternal(bean, _availableJobAggregation,contenu);
        } else {
          console.log('Error ' + res.description);
          this.alertService.error(res.description, res.data);
        }
        this.loading = false;
      }
    );
  }


  private _editWorkshiftRequestInternal(bean: MemoAggregation, availableJobAggregation: AvailableJobAggregation, contenu?: MemoContentWorkShift){
    const modalRef = this.modalService.open(DlgWorkShiftRequestComponent, {size: 'lg'});
    this.alertService.registerModal(modalRef);
    modalRef.componentInstance.populate(bean,availableJobAggregation,contenu);
    modalRef.result.then((result) => {
      if (ModalResult.OK === result){
        // this._getAllMemos();
      }
    }, (reason) => {
      console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
  }


  ngAfterContentChecked(): void {
    if (this.session.manualValidationSchedule === true){
      // console.log('Validate for Errors MANUAL VALIDATION only');
      return;
    }else{
      // console.log('After Content Checked');
      if (!this.model.isThisHoldingSchedulesToBeFilled){
        this.validateForErrors();
      }
    }
  }

  ngAfterContentInit(): void {
    // console.log('After Content Init');
  }

  ngAfterViewChecked(): void {
    // console.log('After View Checked');

    /*
    if (bean.toValidate === true){
      console.log('Starting timer to validate');
      bean.toValidate = false;
      setTimeout(()=>{
        this.validateForErrors();
      },100);
    }
    */

  }

  ngAfterViewInit(): void {
    // console.log('After View Init');
  }



}
